// extracted by mini-css-extract-plugin
export default {"main":"ConfettiPage_main__fCQsW","icon":"ConfettiPage_icon__o0-SN","buttons":"ConfettiPage_buttons__xjB5s"};